const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/v1/";

const DEFAULT_PAYLOAD = {
  system_message: "You are a helpful UPSC assistant",
  answer_type: "generic",
  stream: false,
};

export const sendDemoMentorMind = async (payload = {}) => {
  const token = localStorage.getItem("access_token");
  const requestBody = {
    ...DEFAULT_PAYLOAD,
    ...payload,
    user_id: payload.user_id ?? localStorage.getItem("user_id"),
  };

  if (process.env.REACT_APP_DEFAULT_MODEL && !requestBody.model) {
    requestBody.model = process.env.REACT_APP_DEFAULT_MODEL;
  }

  const response = await fetch(`${API_BASE}demo/mentormind`, {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    let data = null;
    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }
    const requestError = new Error(
      data?.detail || `HTTP error! status: ${response.status}`,
    );
    requestError.status = response.status;
    requestError.data = data;
    throw requestError;
  }

  if (requestBody.stream) {
    return response.body.getReader();
  }

  return response.json();
};

export default sendDemoMentorMind;
